import { AfterViewInit, Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { filter, Subscription } from 'rxjs';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild('navRef') navRef!: ElementRef<HTMLElement>;

    private subscriptions: Subscription = new Subscription();
    private resizeObserver?: ResizeObserver;

    public isLoggedIn: boolean;
    public showBtnLogin: boolean = true;
    public email: string;
    public isAdmin: boolean;
    public showMenu: boolean = false;

    constructor(private authService: AuthService) {}

    ngOnInit(): void {
        this.showBtnLogin = !this.authService.loggedIn;
        this.email = this.authService.email;
        this.isAdmin = this.authService.isAdmin;

        this.subscriptions.add(
            this.authService.resetDataSubject.pipe(filter((x) => x.singIn !== undefined)).subscribe(({ singIn }) => {
                this.showBtnLogin = !singIn;
                this.email = this.authService.email;
                this.isAdmin = this.authService.isAdmin;
            })
        );
    }

    ngAfterViewInit(): void {
        this.resizeObserver = new ResizeObserver((entries) => {
            const height = entries[0].contentRect.height;
            document.documentElement.style.setProperty('--header-height', `${height}px`);
        });
        this.resizeObserver.observe(this.navRef.nativeElement);
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
        this.resizeObserver?.disconnect();
    }

    closeSession(): void {
        this.authService.logout();
    }

    //Cerrar menu automaticamente
    @HostListener('window:scroll', [])
    onWindowScroll() {
        if (this.showMenu) {
            this.showMenu = false;
        }
    }

    toggleMenu() {
        this.showMenu = !this.showMenu;
    }

    onKeydownToggle(event: KeyboardEvent) {
        const keys = ['Enter', ' ']; // Enter o Space
        if (keys.includes(event.key)) {
            event.preventDefault(); // evita scroll con Space
            this.toggleMenu();
        }
    }
}